import * as React from "react";
import { FC } from "react";
import { Edit, EditProps } from "react-admin";
import ArrivalInfoEditForm from "./ArrivalInfoEditForm";

const ArrivalInfoEdit: FC<EditProps> = props => {
  return (
    <Edit {...props} title={"Arrival Info Edit"} component="div">
      <ArrivalInfoEditForm {...props} />
    </Edit>
  );
};

export default ArrivalInfoEdit;
